module.exports = __webpack_public_path__ + "static/media/dashboard1.40016f97.png";